import React from 'react';

const Poland = (props: { width: number }) => {
  return (
    <svg
      id="Flag of Poland"
      viewBox="0 0 16 10"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect fill="#fff" height="10" width="16" />
      <rect fill="#dc143c" height="5" width="16" y="5" />
    </svg>
  );
};

export default Poland;
